    <div id="networkChartDiv">
    </div>
    
    <!-- <div id="NetworkChartTooltip">
        <app-pipeline-update-popup *ngIf="hideUpdateTooltip" [NetworkChartTooltip]="true"
            (hideUpdateTooltip)="tooltipUpdateHide($event)" [updatesObj]="alertObjArray" (refreshNetworkChart)="handleRefreshChart($event)"></app-pipeline-update-popup>
        <app-pipeline-tooltip-link [item]="item" [SelectedNavigation]="false" [popupHeading]="popupHeading" [toolTipData]="toolTipData" *ngIf="hideLinkTooltip"
            (hideLinkTooltip)="tooltipLinkHide()" [sortBySelectedData]="this.sortBySelectedData" [patientReasonCode]="patientReasonCode" [isPendingAndActive]="isPendingAndActive"></app-pipeline-tooltip-link>
    </div> -->

    <ng-template #hideUpdateCustomTooltip>
        <app-pipeline-update-popup [NetworkChartTooltip]="true" (hideUpdateTooltip)="tooltipUpdateHide($event)" [updatesObj]="alertObjArray" (refreshNetworkChart)="handleRefreshChart($event)"></app-pipeline-update-popup>
    </ng-template>
    
    <ng-template #hideLinkCustomTooltip>
        <app-pipeline-tooltip-link [item]="item" [SelectedNavigation]="false" [popupHeading]="popupHeading" [toolTipData]="toolTipData" (hideLinkTooltip)="tooltipLinkHide()" [sortBySelectedData]="this.sortBySelectedData" [patientReasonCode]="patientReasonCode" [isPendingAndActive]="isPendingAndActive"></app-pipeline-tooltip-link>
    </ng-template>
